<p-dropdown [styleClass]="'full-width'" [options]="optionValues" appendTo="body" class="custom-dropdown" [ngModelOptions]="{standalone: true}"
            [(ngModel)]="selectedValue" optionLabel="Description" optionValue="YesNoValue" (onChange)="emit($event)" tabindex="0"
            [disabled]="disabled" [virtualScroll]="true"></p-dropdown>
